import React, { FC } from 'react';
import { Icon, IconProps } from '@agria/theme/src/components/icon/Icon';

export const Plus: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M26 14.6665h-8.6666V5.99984c0-.73334-.6-1.33334-1.3334-1.33334-.7333 0-1.3333.6-1.3333 1.33334v8.66666H6.00002c-.73333 0-1.33333.6-1.33333 1.3333 0 .7334.6 1.3334 1.33333 1.3334h8.66668v8.6666c0 .7334.6 1.3334 1.3333 1.3334.7334 0 1.3334-.6 1.3334-1.3334v-8.6666H26c.7334 0 1.3334-.6 1.3334-1.3334 0-.7333-.6-1.3333-1.3334-1.3333Z"
    />
  </Icon>
);
